import { MessageCircle, ArrowRight, Phone } from "lucide-react";
import { buildWhatsAppLink, PHONE_NUMBER_TEL, PHONE_NUMBER_DISPLAY } from "../lib/contact";

export const CTABanner = () => {
    return (
        <section
            data-testid="cta-banner"
            className="relative bg-[#FFC107] overflow-hidden"
        >
            {/* Decorative big text */}
            <div
                aria-hidden
                className="pointer-events-none absolute inset-0 flex items-center justify-center"
            >
                <span className="font-display text-[28vw] leading-none text-black/5 uppercase select-none whitespace-nowrap">
                    Lift Now
                </span>
            </div>

            {/* Caution stripe top */}
            <div className="caution-stripes h-2" />

            <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
                <div className="lg:col-span-7 reveal">
                    <div className="flex items-center gap-3 mb-5">
                        <span className="w-10 h-[2px] bg-black" />
                        <span className="font-body text-xs uppercase tracking-[0.32em] text-black/80">
                            Urgent Lift?
                        </span>
                    </div>
                    <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl uppercase text-black leading-[0.88]">
                        Need a crane
                        <br />
                        urgently?
                    </h2>
                    <p className="mt-6 max-w-xl font-body text-base lg:text-lg text-black/80 leading-relaxed">
                        Tell us the load, the location and the timeline. We can
                        usually have a crane on-site within hours across
                        Mumbai, Thane, Bhiwandi &amp; Wada.
                    </p>
                </div>

                <div className="lg:col-span-5 reveal flex flex-col gap-3">
                    <a
                        href={buildWhatsAppLink(
                            "URGENT: I need a crane on-site. Please call me back ASAP.",
                        )}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="cta-banner-whatsapp"
                        className="group inline-flex items-center justify-between gap-4 bg-black text-[#FFC107] hover:bg-neutral-900 font-body font-bold text-base uppercase tracking-[0.16em] px-7 py-6 transition-all duration-200 hover:-translate-y-0.5"
                    >
                        <span className="inline-flex items-center gap-3">
                            <MessageCircle size={22} strokeWidth={2.5} />
                            Chat on WhatsApp
                        </span>
                        <ArrowRight
                            size={20}
                            className="transition-transform duration-200 group-hover:translate-x-1"
                        />
                    </a>
                    <a
                        href={`tel:${PHONE_NUMBER_TEL}`}
                        data-testid="cta-banner-call"
                        className="inline-flex items-center justify-between gap-4 border-2 border-black hover:bg-black hover:text-[#FFC107] text-black font-body font-bold text-base uppercase tracking-[0.16em] px-7 py-6 transition-colors"
                    >
                        <span className="inline-flex items-center gap-3">
                            <Phone size={20} strokeWidth={2.5} />
                            Call {PHONE_NUMBER_DISPLAY}
                        </span>
                        <ArrowRight size={20} />
                    </a>
                </div>
            </div>

            <div className="caution-stripes h-2" />
        </section>
    );
};
